export const transferToBankApiHandler = {
  getAllTransferToBankRequests: {
    method: "GET",
    path: () => `wallet/transfer-to-bank/all`,
    params: {} as {'skip'?: string | number, 'take'?: string | number, 'search'?: string | number, 'status'?: (string | number)[]}
  },
  modifyTransferToBankRequest: {
    method: "POST",
    path: (payload: { id: string | number }) => `wallet/transfer-to-bank/${payload.id}`
  }
};